"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteDistributorCustomFilter = void 0;
const routes_1 = require("../../routes");
const deleteDistributorCustomFilter = (client) => async (distributorId, cropId, categoryId) => {
    const queryParams = new URLSearchParams();
    queryParams.append('crop_id', cropId);
    queryParams.append('category_id', categoryId);
    const url = `${routes_1.ENDPOINTS.DELETE_PARTNER_CUSTOM_FILTER.applyParams(distributorId)}?${queryParams.toString()}`;
    const { data } = await client.delete(url);
    return data;
};
exports.deleteDistributorCustomFilter = deleteDistributorCustomFilter;
